import { styled } from '@mui/material'
import { css } from '@emotion/react'
import MuiTableCell from '@mui/material/TableCell'
import { TableCellProps } from './TableCell.types'

export const TableCell = styled(MuiTableCell, {
  shouldForwardProp: (props) => props !== 'header',
})<TableCellProps>`
  padding: 16px 12px;

  ${({ header, theme }) => {
    const typo = header ? {} : theme.typography.body3
    const { fontSize, fontWeight, letterSpacing, lineHeight } = typo
    return css`
      font-size: ${fontSize ?? '14px'};
      font-weight: ${fontWeight ?? 700};
      letter-spacing: ${letterSpacing ?? 'normal'};
      line-height: ${lineHeight ?? '21px'};
    `
  }}
`
